import { createSlice } from "@reduxjs/toolkit";

const roleslice = createSlice({
  name: "permission",
  initialState:[],
  reducers: {
    getpermission(state, action) {
      return action.payload; // assuming payload is always an array
    }
  }
});

export const { getpermission } = roleslice.actions;
export default roleslice.reducer;
